module.exports = __webpack_public_path__ + "static/media/photography08.8c453ccb.png";